import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { INITIAL_DASHBOARD_FILTER_PARAMS } from '../../../store/user/constants';
import Select from 'react-select';
import Input from '../../common/form-elements/input/input';
import IconButton from '../../common/icon-button/icon-button';
import { changeDashboardLibraryFilters } from '../../../store/user/user-actions';
import isEqual from 'lodash/isEqual';

const PERMISSION_OPTIONS = [
    { value: 'private', label: 'Private' },
    { value: 'public', label: 'Public' }
];

const SHARED_OPTIONS = [
    { value: 'shared', label: 'Shared' },
    { value: 'not shared', label: 'Not shared' }
];

const INITIAL_STATE = {
    queryParams: INITIAL_DASHBOARD_FILTER_PARAMS,
    selectedTagsOptions: [],
    selectedPermissionOption: null,
    selectedSharedByOption: null,
    showDashboardsFilter: false
};

const DashboardFilters = ({
    availableTags,
    queryParamsFromStore,
    isMobileDevice,
    closeFilters,
    changeDashboardLibraryFilters
}) => {
    const [queryParams, setQueryParams] = useState(queryParamsFromStore || INITIAL_STATE.queryParams);
    const [selectedTagsOptions, setSelectedTagsOptions] = useState(INITIAL_STATE.selectedTagsOptions);
    const [selectedPermissionOption, setSelectedPermissionOption] = useState(INITIAL_STATE.selectedPermissionOption);
    const [selectedSharedByOption, setSelectedSharedByOption] = useState(INITIAL_STATE.selectedSharedByOption);
    const [filterTagsOptions, setFilterTagsOptions] = useState(
        Object.keys(availableTags).map(tag => ({ ...availableTags[tag] })) || []
    );

    useEffect(() => {
        setFilterTagsOptions(
            Object.keys(availableTags).map(tag => ({ ...availableTags[tag] }))
        );
    }, [availableTags]);

    useEffect(() => {
        setQueryParams(queryParamsFromStore);
    }, [queryParamsFromStore]);

    useEffect(() => {
        const selectedTags = []
        if(queryParams.tagIds !== null) {
            const availableTagsKeys = Object.keys(availableTags);
            availableTagsKeys.forEach(item => {
                queryParams.tagIds.forEach(elemetn => {
                    if(elemetn === availableTags[item].id) {
                        selectedTags.push(availableTags[item]);
                    }
                })
            })
        }

        setSelectedTagsOptions(selectedTags);
    }, [queryParams.tagIds, availableTags]);

    useEffect(() => {
        let selectedPermissionOption = null;
        if(queryParams.isPrivate !== null) {
            selectedPermissionOption = queryParams.isPrivate ? PERMISSION_OPTIONS[0] : PERMISSION_OPTIONS[1];
        }
        setSelectedPermissionOption(selectedPermissionOption);
    }, [queryParams.isPrivate]);

    useEffect(() => {
        let selectedSharedByOption = null;
        if(queryParams.isShared !== null) {
            selectedSharedByOption = queryParams.isShared ? SHARED_OPTIONS[0] : SHARED_OPTIONS[1];
        }
        setSelectedSharedByOption(selectedSharedByOption);
    }, [queryParams.isShared]);

    const handleFilterApply = e => {
        e.preventDefault();
        let showDashboardsFilter = !isEqual(queryParams, INITIAL_DASHBOARD_FILTER_PARAMS);
        if (isMobileDevice) {
            showDashboardsFilter = false;
        }
        changeDashboardLibraryFilters(
            queryParams,
            showDashboardsFilter
        );
        if (isMobileDevice) {
            closeFilters();
        }
    };

    const setSearchCriteria = searchCriteria => {
        setQueryParams(queryParams => ({
            ...queryParams,
            searchCriteria
        }));
    };

    const handleSelectedTagsChange = selectedTags => {
        const tagIds = selectedTags ? selectedTags.map(tagId => tagId.id) : null;
        setQueryParams(queryParams => ({
            ...queryParams,
            tagIds
        }));
        setSelectedTagsOptions(selectedTags);
    };

    const handleSelectedPermissionChange = selectedPermission => {
        const isPrivate = selectedPermission && selectedPermission.value === 'private';
        setQueryParams(queryParams => ({
            ...queryParams,
            isPrivate
        }));
        setSelectedPermissionOption(selectedPermission);
    };

    const handleSelectedSharedByChange = sharedByOption => {
        const isShared = sharedByOption && sharedByOption.value === 'shared';
        setQueryParams(queryParams => ({
            ...queryParams,
            isShared
        }));
        setSelectedSharedByOption(sharedByOption);
    };

    const handleFilterReset = () => {
        setQueryParams(INITIAL_STATE.queryParams);
        setSelectedTagsOptions(INITIAL_STATE.selectedTagsOptions);
        setSelectedPermissionOption(INITIAL_STATE.selectedPermissionOption);
        setSelectedSharedByOption(INITIAL_STATE.selectedSharedByOption);
        changeDashboardLibraryFilters(
            INITIAL_STATE.queryParams,
            false
        );
        if (isMobileDevice) {
            closeFilters();
        }
    };

    return (
        <div className={`
            glu-dashboard-library
            glu-dashboard-library__filters
            ${isMobileDevice ? 'glu-dashboard-library__mobile-filters' : 'glu-dashboard-library__filters'}
            glu-content__separator
            glu-content__separator--bottom
        `}
        >
            <div className="glu-content__section--big glu-flex glu-flex-justify-space-between glu-flex-align-center">
                <div className="glu-h3">Filters</div>
                <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                    <IconButton
                        onClick={closeFilters}
                        icon="close"
                    />
                </div>
            </div>
            <div className={`glu-dashboard-filters-section
                ${isMobileDevice && 'glu-dashboard-mobile-filters-section'}`}
            >
                <form onSubmit={handleFilterApply}>
                    <div className="filter-form-wrapper glu-flex-row glu-flex-row--md">
                        <div className="filter-form glu-col-lg-20 glu-col-md-17 glu-col-xs-24 glu-col-pad--sm">
                            <div className={`${!isMobileDevice && 'glu-row'}`}>
                                <div className="filter-form__item glu-col-md-6 glu-col-sm-12 glu-col-24">
                                    <label className="glu-label">Search</label>
                                    <Input
                                        autoFocus
                                        placeholder="Search by dashboard name..."
                                        value={queryParams.searchCriteria}
                                        onChange={setSearchCriteria}
                                        className="glu-form-input-pad"
                                    />
                                </div>
                                <div className="filter-form__item glu-col-md-6 glu-col-sm-12 glu-col-24">
                                    <label className="glu-label">Tags</label>
                                    <Select
                                        placeholder="Select tags"
                                        isMulti
                                        closeMenuOnSelect={false}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        options={filterTagsOptions}
                                        onChange={handleSelectedTagsChange}
                                        value={selectedTagsOptions}
                                    />
                                </div>
                                <div className="filter-form__item glu-col-md-6 glu-col-sm-12 glu-col-24">
                                    <label className="glu-label">Permissions</label>
                                    <Select
                                        placeholder="Select permissions"
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        closeMenuOnSelect
                                        options={PERMISSION_OPTIONS}
                                        onChange={handleSelectedPermissionChange}
                                        value={selectedPermissionOption}
                                        NoOptionsMessage
                                        isClearable
                                    />
                                </div>
                                <div className="filter-form__item glu-col-md-6 glu-col-sm-12 glu-col-24">
                                    <label className="glu-label">Shared</label>
                                    <Select
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        closeMenuOnSelect
                                        placeholder="Select shared option"
                                        options={SHARED_OPTIONS}
                                        onChange={handleSelectedSharedByChange}
                                        value={selectedSharedByOption}
                                        NoOptionsMessage
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className="glu-col-xs-24 glu-col-sm-12 glu-col-md-7 glu-col-lg-4
                                            glu-col-pad--sm glu-page__buttons"
                        >
                            <div className="filter-form-buttons glu-row glu-row--margin-top">
                                <div className={`${!isMobileDevice && 'glu-col-12'}`}>
                                    <button
                                        className="glu-col-24 glu-btn glu-btn--secondary"
                                        type="button"
                                        disabled={isEqual(queryParamsFromStore, INITIAL_DASHBOARD_FILTER_PARAMS)}
                                        onClick={handleFilterReset}
                                    >
                                        Reset filters
                                    </button>
                                </div>
                                <div className={`${!isMobileDevice && 'glu-col-12'}`}>
                                    <button
                                        className="glu-col-24 glu-btn glu-btn--primary"
                                        disabled={isEqual(queryParams, queryParamsFromStore)}
                                        type="submit"
                                    >
                                        Apply filters
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

DashboardFilters.propTypes = {
    availableTags: PropTypes.objectOf(PropTypes.any).isRequired,
    queryParamsFromStore: PropTypes.objectOf(PropTypes.any).isRequired,
    selectedOrganization: PropTypes.objectOf(PropTypes.any)
};

DashboardFilters.defaultProps = {
    selectedOrganization: null
};

const mapStateToProps = ({ dashboardReducer, userReducer }) => ({
    availableTags: dashboardReducer.availableTags,
    queryParamsFromStore: userReducer.queryParams,
    selectedOrganization: userReducer.selectedOrganization
});

const mapDispatchToProps = dispatch => ({
    changeDashboardLibraryFilters: (
        queryParams,
        showDashboardsFilter
    ) => changeDashboardLibraryFilters(
        dispatch,
        queryParams,
        showDashboardsFilter
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardFilters);
